import Modal from "@ui-components/Modal";
import {FormattedMessage, useIntl} from "react-intl";
import Button from "@ui-components/Button";
import {EditSurveyModalProps} from "./types";
import React, {useEffect, useState} from "react";
import {SurveysSelector} from "@feature/worksites/surveys-selector";
import {ServiceSurveysWithIdSchema} from "@feature/types";
import Input from "@ui-components/Input";

export const EditSurveyModal = ({
  survey,
  designSurveys,
  services,
  creators,
  onClose,
  onConfirm,
  submitting,
}: EditSurveyModalProps) => {

  // hooks
  const intl = useIntl();

  // state
  const [name, setName]
    = useState(survey?.name || "");
  const [selectedSourceSurveys, setSelectedSourceSurveys]
    = useState<ServiceSurveysWithIdSchema[]>([]);

  // utilities
  const hasDesignSurveys = designSurveys?.length > 0;

  useEffect(() => {
    if (!hasDesignSurveys) return;
    setName(
      selectedSourceSurveys.length > 0
        ? `${selectedSourceSurveys.map(s => s.name).join(", ")} - ${intl.formatMessage({id: "quotation_service"})}`
        : ""
    );
  }, [selectedSourceSurveys]);  // eslint-disable-line

  return (
    // @ts-ignore
    <Modal
      onExit={onClose}
    >
      <div className="flex flex-col gap-6">

        {/* --------------- title --------------- */}
        <h1 className="text-2xl">
          {!!survey
            ? <FormattedMessage id="edit_survey" defaultMessage="Modifica configurazione" />
            : <FormattedMessage id="create_survey" defaultMessage="Crea una configurazione" />
          }
        </h1>

        {hasDesignSurveys && <>
          {/* --------------- surveys selector --------------- */}
          <div className="flex flex-col gap-4">
            <h3 className="text-base font-semibold">
              <FormattedMessage
                id="select_one_or_more_surveys_prompt"
                defaultMessage="Seleziona una o più progettazioni da convertire"
              />
            </h3>
            <div>
              <SurveysSelector
                services={services}
                surveys={designSurveys}
                creators={creators}
                value={selectedSourceSurveys}
                onChange={setSelectedSourceSurveys}
                onlyOne
              />
            </div>
          </div>
          {/* --------------- separator --------------- */}
          <div className="flex flex-row gap-2 items-center">
            <div className="flex-1 border-b border-gray-200" />
            <div className="text-gray-400 lowercase leading-none mb-0.5">
              <FormattedMessage id="or_ext" defaultMessage="Oppure" />
            </div>
            <div className="flex-1 border-b border-gray-200" />
          </div>
        </>}

        {/* --------------- name setter --------------- */}
        <div className="flex flex-col gap-2">
          <h3 className="text-base font-semibold">
            {
              !hasDesignSurveys
                ? <FormattedMessage id="survey_name" defaultMessage="Nome configurazione" />
                : <FormattedMessage id="create_new_survey" defaultMessage="Crea una nuova configurazione" />
            }
          </h3>
          {/* @ts-ignore */}
          <Input
            type="text"
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setName(e.target.value); }}
            placeholder={intl.formatMessage({ id: "none" })}
            hideBottomMargin
          />
        </div>

        {/* --------------- confirm cta --------------- */}
        <Button
          full
          onClick={() => {
            onConfirm(name || null, selectedSourceSurveys);
          }}
          submitting={submitting}
          disabled={submitting}
        >
          <FormattedMessage
            id="confirm"
            defaultMessage="Conferma"
          />
        </Button>
      </div>
    </Modal>
  )
}